import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToPageProps } from 'interview/i18n'
import { Flex } from 'components/styled/containers/flex'
import { Body, H3 } from 'components/styled/typography'
import { I18nPageType } from 'interview/i18n-types'

function Saved({ i18n }: { i18n: I18nPageType }) {
  return (
    <Flex alignItems="flex-start" flexDirection="column" mt="s32">
      <H3 mb="s16">{i18n.saved.title}</H3>
      <Body>{i18n.saved.description}</Body>
      <Body fontWeight={600}>{i18n.saved.remember}</Body>
      <Body>{i18n.saved.deleteHistory}</Body>
    </Flex>
  )
}

export default connect(mapLanguageToPageProps())(Saved)
